/* ============================================================
   KHAVIYAR - free-delivery progress + dispatch countdown +
   delivery promise (Sydney era)

   v9, 24 Oct 2026: every option is $39.95; refrigerated (CoolCartons)
   and Sydney same-day are free from $199.95, Express Delivery from
   $299.95 (matches the rates worker v9). 19 Sep 2026: the strip no longer quotes flat rates; parcels are Express Delivery next-day only (worker v8, 23 Oct 2026).
   v17, 4 Nov 2026: Express Delivery on every one-business-day lane (10am Mon-Wed, 1 to 3 business days, never the
   recommended option); weekend Urgent Delivery by 12pm at a flat $149.95 beside the Monday run; Refrigerated Courier across all 40 CoolCartons zones.

   1. Cart drawer + cart page strip: free-delivery progress bar
      plus next dispatch countdown.
   2. Delivery certainty line under the buy buttons.

   All times Australia/Sydney. Cutoffs: 12pm for the Sydney
   same-day zone (Mon-Fri, 12pm urgent Sat-Sun), 10am for Express Delivery (Mon-Wed),
   Monday 3pm for Refrigerated Courier. The line here is postcode-agnostic so it quotes all three.

   Additive only. Injects its own styles. Never throws.
   ============================================================ */
(function () {
  "use strict";

  var TZ = "Australia/Sydney";
  var PRE = { gp: "2026-10-29", mp: "2026-11-02", cc: "2026-11-03" };   /* first dispatch days (24 Oct 2026) */
  var MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var CUTOFF_GP = 12 * 60;
  var CUTOFF_EXP = 11 * 60;
  var FLAT = 3995;       /* cents - every paid delivery option */
  var FREE_LOW = 19995;  /* refrigerated + Sydney same-day free from $199.95 */
  var FREE_HIGH = 29995; /* Express Delivery free from $299.95 */
  var HOLIDAYS = ["2026-10-05","2026-12-25","2026-12-28","2027-01-01","2027-01-26","2027-03-26","2027-03-29","2027-06-14","2027-10-04"];
  var DAYS = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

  var CSS = [
    ".kh-ship{margin:0 0 14px;padding:12px 14px;border:1px solid rgba(200,169,107,.35);",
    "border-radius:6px;background:rgba(200,169,107,.07);font-family:Montserrat,system-ui,sans-serif}",
    ".kh-ship__text{font-size:13px;line-height:1.4;letter-spacing:.01em}",
    ".kh-ship__text strong{font-weight:600}",
    ".kh-ship__note{display:block;margin-top:3px;font-size:11.5px;opacity:.75}",
    ".kh-ship__track{margin-top:8px;height:3px;border-radius:3px;background:rgba(200,169,107,.22);overflow:hidden}",
    ".kh-ship__fill{display:block;height:100%;background:#c8a96b;transition:width .35s ease}",
    ".kh-deliver{margin:12px 0 0;padding:10px 12px;border-left:2px solid #c8a96b;",
    "background:rgba(200,169,107,.07);font-family:Montserrat,system-ui,sans-serif;",
    "font-size:13px;line-height:1.45;letter-spacing:.01em}",
    ".kh-deliver b{font-weight:600}"
  ].join("");

  function injectCss() {
    if (document.getElementById("kh-ship-css")) return;
    var s = document.createElement("style");
    s.id = "kh-ship-css";
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function now() {
    try {
      var parts = new Intl.DateTimeFormat("en-AU", {
        timeZone: TZ, year: "numeric", month: "numeric", day: "numeric",
        weekday: "long", hour: "numeric", minute: "numeric", hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { if (p.type !== "literal") o[p.type] = p.value; });
      var hh = parseInt(o.hour, 10); if (hh === 24) hh = 0;
      return {
        y: parseInt(o.year, 10), m: parseInt(o.month, 10), d: parseInt(o.day, 10),
        dow: DAYS.indexOf(o.weekday), mins: hh * 60 + parseInt(o.minute, 10)
      };
    } catch (e) { return null; }
  }
  function pad(n) { return ("0" + n).slice(-2); }
  function isHoliday(y, m, d) { return HOLIDAYS.indexOf(y + "-" + pad(m) + "-" + pad(d)) > -1; }

  function nextDispatch(maxDow, n, cutoffMin, minIso) {
    var dt = new Date(Date.UTC(n.y, n.m - 1, n.d)), held = false;
    if (minIso && dt.toISOString().slice(0, 10) < minIso) { dt = new Date(minIso + "T00:00:00Z"); held = true; }
    for (var i = 0; i <= 35; i++) {
      var w = dt.getUTCDay();
      var ok = w >= 1 && w <= maxDow && !isHoliday(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
      if (ok && (held || i > 0 || n.mins < cutoffMin)) {
        return { today: !held && i === 0, held: held, dowName: held ? DAYS[w] + " " + dt.getUTCDate() + " " + MONTHS[dt.getUTCMonth()] : DAYS[w] };
      }
      dt.setUTCDate(dt.getUTCDate() + 1);
    }
    return null;
  }
  function countdown(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return h > 0 ? h + "h " + m + "m" : m + "m";
  }

  /* ---- 1. cart strip ---------------------------------------------------- */

  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function progressMarkup() {
    if (!lastCart || !lastCart.item_count) return "";
    var total = lastCart.total_price;
    var bar = function (pct) { return '<div class="kh-ship__track"><span class="kh-ship__fill" style="width:' + pct + '%"></span></div>'; };
    if (total >= FREE_HIGH) {
      return '<div class="kh-ship__text"><strong>Free delivery unlocked</strong></div>' + bar(100);
    }
    if (total >= FREE_LOW) {
      var more = FREE_HIGH - total;
      return '<div class="kh-ship__text"><strong>Free Refrigerated Courier and same-day delivery unlocked</strong><span class="kh-ship__note">Express Delivery is free from $299.95 where Refrigerated Courier is not offered.</span></div>' + bar(Math.round((total / FREE_HIGH) * 100));
    }
    var remaining = FREE_LOW - total;
    var pct = Math.max(2, Math.min(100, Math.round((total / FREE_LOW) * 100)));
    return '<div class="kh-ship__text">Add <strong>' + money(remaining) + '</strong> for free refrigerated and same-day delivery</div>' + bar(pct);
  }

  function stripMarkup() {
    return progressMarkup();   /* 24 Oct 2026 (Amin): far fewer words. The cart's Delivery block carries the dispatch and arrival days. */
    var n = now();
    var tail = " Opt in to email + SMS tracking so it hits the fridge the moment it lands.";
    if (!n) return '<div class="kh-ship__text"><strong>Same-day Sydney &middot; Refrigerated Courier</strong><span class="kh-ship__note">Free Refrigerated Courier and same-day delivery from $199.95. Order by 12pm Sydney metro, Monday 3pm for Refrigerated Courier, 10am Monday to Wednesday for Express Delivery.' + tail + "</span></div>";
    var parcels = nextDispatch(3, n, CUTOFF_EXP, PRE.mp);
    var sydney = nextDispatch(5, n, CUTOFF_GP, PRE.gp);
    var head, note;
    if ((parcels && parcels.held) || (sydney && sydney.held)) {
      head = "<strong>Fresh Oscietra, in stock now</strong>";
      note = "Sydney same-day from " + (sydney ? sydney.dowName : "Thursday 29 October") + ", Express Delivery from " + (parcels ? parcels.dowName : "Monday 2 November") + ", Refrigerated Courier from Tuesday 3 November.";
      return progressMarkup() + '<div class="kh-ship__text" style="margin-top:8px">' + head + '<span class="kh-ship__note">' + note + "</span></div>";
    }
    if (parcels && parcels.today) {
      head = "Order in the next <strong>" + countdown(CUTOFF_EXP - n.mins) + "</strong> for today&rsquo;s cold dispatch";
      note = "Sydney metro: delivered today by 5pm. Refrigerated Courier: order by Monday 3pm. Express Delivery next business day where we reach you in one day, order by 10am.";
    } else if (sydney && sydney.today) {
      head = "Order in the next <strong>" + countdown(CUTOFF_GP - n.mins) + "</strong> for Sydney same-day delivery by 5pm";
      note = "Express Delivery orders are held cold for " + (parcels ? parcels.dowName : "Monday") + "&rsquo;s dispatch, Monday to Wednesday only. Refrigerated Courier: order by Monday 3pm.";
    } else {
      head = "<strong>Same-day Sydney &middot; Refrigerated Courier</strong>";
      note = "Next dispatch: Sydney same-day " + (sydney ? sydney.dowName : "Monday") + ", Express Delivery " + (parcels ? parcels.dowName : "Monday") + ". Order by 12pm Sydney metro, 10am for Express Delivery Monday to Wednesday. Refrigerated Courier: order by Monday 3pm.";
    }
    return progressMarkup() + '<div class="kh-ship__text" style="margin-top:8px">' + head + '<span class="kh-ship__note">' + note + tail + "</span></div>";
  }

  var lastCart = null;
  var painting = false;

  function hosts() {
    var out = [];
    var drawer = document.querySelector("cart-drawer-component dialog .cart-drawer__content") ||
      document.querySelector("cart-drawer-component dialog");
    if (drawer) out.push(drawer);
    var page = document.querySelector(".cart__items") ||
      document.querySelector("cart-items-component") ||
      document.querySelector(".cart__summary");
    if (page && out.indexOf(page) === -1) out.push(page);
    return out;
  }

  function paint() {
    if (painting) return;
    painting = true;
    try {
      var empty = lastCart && !lastCart.item_count;
      hosts().forEach(function (host) {
        var el = host.querySelector(".kh-ship");
        if (empty) {
          if (el && el.parentNode) el.parentNode.removeChild(el);
          return;
        }
        if (!el) {
          el = document.createElement("div");
          el.className = "kh-ship";
          host.insertBefore(el, host.firstChild);
        }
        var next = stripMarkup();
        if (el.innerHTML !== next) el.innerHTML = next;
      });
    } catch (e) { /* never break the page */ }
    painting = false;
  }

  var inflight = false;
  function refresh() {
    if (inflight) return;
    inflight = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { inflight = false; lastCart = c; paint(); })
      .catch(function () { inflight = false; paint(); });
  }

  /* ---- 2. delivery promise under buy buttons ---------------------------- */

  function promise() {
    var n = now();
    if (!n) return "Refrigerated Courier, same-day Sydney, or Express Delivery next business day where we reach you in one day. Order by <b>12pm AEST</b> Sydney metro, <b>Monday 3pm AEST</b> for Refrigerated Courier, <b>10am AEST</b> Monday to Wednesday for Express Delivery.";
    var parcels = nextDispatch(3, n, CUTOFF_EXP, PRE.mp);
    if (parcels && parcels.held) return "Fresh Oscietra, in stock now. Sydney same-day from <b>Thursday 29 October</b>, Express Delivery from <b>" + parcels.dowName + "</b>, Refrigerated Courier from <b>Tuesday 3 November</b>.";
    /* v17 (4 Nov 2026): lead with Sydney same-day and Refrigerated Courier. Express Delivery on every one-business-day lane, 10am Mon-Wed, never the recommended option. */
    if ((n.dow === 0 || n.dow === 6) && n.mins < 12 * 60) {
      return "Order in the next <b>" + countdown(12 * 60 - n.mins) + "</b> and Sydney metro is delivered <b>today by 5pm</b> (weekend Urgent Delivery, flat $149.95), or take Monday&rsquo;s same-day run. Everywhere else: Refrigerated Courier, order by Monday 3pm AEST.";
    }
    var sydney = nextDispatch(5, n, CUTOFF_GP, PRE.gp);
    if (sydney && sydney.today) {
      return "Order in the next <b>" + countdown(CUTOFF_GP - n.mins) + "</b> and Sydney metro is delivered <b>today by 5pm</b>. Refrigerated Courier: order by Monday 3pm AEST, dispatched Tuesday. Express Delivery dispatched <b>" + (parcels ? (parcels.today ? "today" : parcels.dowName) : "Monday") + "</b> where we reach you next business day, 1 to 3 business days.";
    }
    return "Order now for Sydney same-day delivery <b>" + (sydney ? sydney.dowName : "Monday") + "</b>, Refrigerated Courier dispatched <b>Tuesday</b>, Express Delivery dispatched <b>" + (parcels ? parcels.dowName : "Monday") + "</b>. Check your postcode above.";
  }

  function placeDelivery() {
    try {
      var text = promise();
      var anchors = [];
      var main = document.querySelector("main[data-template]");
      var tpl = main ? (main.getAttribute("data-template") || "") : "";
      /* 24 Oct 2026: no delivery paragraph under the product page buy button any more (the timeline covers it). */
      Array.prototype.slice.call(document.querySelectorAll("[data-kh-buy]"))
        .forEach(function (p) { anchors.push(p); });
      anchors.forEach(function (a) {
        if (!a.parentNode) return;
        if (a.parentNode.querySelector(":scope > .kh-deliver")) return;
        var d = document.createElement("div");
        d.className = "kh-deliver";
        d.innerHTML = text;
        a.parentNode.insertBefore(d, a.nextSibling);
      });
    } catch (e) { /* never break the page */ }
  }

  /* ---- wiring ---------------------------------------------------------- */

  function watchDrawer() {
    var c = document.querySelector("cart-drawer-component");
    if (!c || typeof MutationObserver === "undefined") return;
    var t = null;
    new MutationObserver(function () {
      if (painting) return;
      clearTimeout(t);
      t = setTimeout(paint, 60);
    }).observe(c, { childList: true, subtree: true });
  }

  function start() {
    injectCss();
    placeDelivery();
    refresh();
    watchDrawer();
    document.addEventListener("cart:update", function () { refresh(); });
    document.addEventListener("cart:add", function () { refresh(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

